import { Http, Schema } from "../../../../../@types";
import { enums } from "../../../../../../../shim/jsbridge";
import Name from "../../../../../../search/schema/components/Name";

const { analyzer: { URLANALYZER = 1 } = {} } = enums || {};

export const http: Schema<Http> = {
  fields: [
    {
      name: "uri",
      displayTitle: "Uri",
      sortable: true,
      component: (d: Http) => (
        <Name
          data={{
            file_name: d.uri?.trim(),
            int_submission_analyzer: URLANALYZER
          }}
        />
      )
    },
    {
      name: "data",
      displayTitle: "Data",
      sortable: true,
      component: (d: Http) => (
        <pre className="dynamic-analysis-tool-pre">{d.data?.trim()}</pre>
      )
    }
  ]
};
